import { type FunctionComponent } from 'react';
import { type PlaAttribute } from '../../../types/product.types';

type ProductSpecListProps = {
	specs: PlaAttribute[];
	testId?: string;
};

const ProductSpecList: FunctionComponent<ProductSpecListProps> = ({ specs, testId }) => (
	<ul className="flex flex-column items-start ma0 f6" data-testid={testId}>
		{specs.map(({ id, name, values, units }) => (
			<li key={`${id}-${name}`} className="tl mh0 mv1 pa0">
				<span className="font-medium">{name}:</span>
				<span className="ml2">
					{values} {units}
				</span>
			</li>
		))}
	</ul>
);

export type ProductKeySpecsProps = {
	specs: PlaAttribute[];
};

export const ProductKeySpecs: FunctionComponent<ProductKeySpecsProps> = ({ specs }) => (
	<div className="pt3">
		<div className="font-medium pb2">Key Specifications</div>
		<div className={`flex flex-column flex-row-ns pv2`}>
			<ProductSpecList testId="Key Specs List Left" specs={specs.slice(0, Math.ceil(specs.length / 2))} />
			{specs.length > 1 && (
				<ProductSpecList testId="Key Specs List Right" specs={specs.slice(Math.ceil(specs.length / 2), specs.length)} />
			)}
		</div>
	</div>
);
